import { Currency } from '@seapoint/server/enums';
import { useState } from 'react';
import { Button } from '../../../../design-system/button/button';
import { Modal, ModalContent, ModalDescription, ModalTitle } from '../../../../design-system/modal/modal';
import { Stack } from '../../../../design-system/stack/stack';
import { SupportedCountryCurrency } from '../../../../types/supported-country-currency';
import { OpenSeapointAccount } from '../../../payroll/components/open-seapoint-account/open-seapoint-account';

type MissingSeapointAccountProps = {
  requiredCurrency?: SupportedCountryCurrency;
};

const getAccountTypeText = (currency: SupportedCountryCurrency): string => {
  switch (currency) {
    case Currency.GBP:
      return 'a GBP Seapoint account';
    case Currency.EUR:
      return 'an EUR Seapoint account';
  }
};

export const MissingSeapointAccount = ({ requiredCurrency }: MissingSeapointAccountProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const accountTypeText = requiredCurrency ? getAccountTypeText(requiredCurrency) : 'a Seapoint account';

  return (
    <Stack space={4}>
      <p className="leading-[20px] font-normal tracking-[-0.02em] text-muted-foreground">
        Give your team spending power with instant virtual cards and cancel cards instantly when needed.
      </p>

      <p className="leading-[20px] font-normal tracking-[-0.02em] text-muted-foreground">
        To create your first card, you need to open {accountTypeText}.
      </p>

      <div className="mt-3 w-full">
        <OpenSeapointAccount onOpenAccount={() => setIsModalOpen(true)} />
      </div>

      {isModalOpen && (
        <Modal open={isModalOpen} onOpenChange={setIsModalOpen}>
          <ModalContent className="h-auto w-[400px]">
            <ModalTitle className="px-4 pt-4">Open Seapoint Account</ModalTitle>
            <ModalDescription className="p-4">
              <Stack space={6} align="stretch">
                <p className="text-sm leading-[20px] tracking-[-0.02em] text-muted-foreground">
                  To open {accountTypeText}, please contact someone from the Seapoint team.
                </p>
                <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
                  Close
                </Button>
              </Stack>
            </ModalDescription>
          </ModalContent>
        </Modal>
      )}
    </Stack>
  );
};
